module.exports = __webpack_public_path__ + "img/observa-top.7bd65d4f.png";